import { TextField, Typography, Box } from "@mui/material";

const TextFieldComponent = ({
  label,
  value = "",
  onChange = () => {},
  placeholder = "",
}) => {
  return (
    <Box>
      <Typography sx={{ mt: "10px" }}>{label}</Typography>
      <TextField
        fullWidth
        variant="outlined"
        margin="normal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || `Enter ${label}`}
        sx={{
          backgroundColor: "white",
          borderRadius: "4px",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "& .MuiInputBase-input": {
              padding: "14px 14px",
            },
          },
        }}
      />
    </Box>
  );
};

export default TextFieldComponent;
